// extracted by mini-css-extract-plugin
module.exports = {"container":"RecycleBin_container__tj5x0","Title":"RecycleBin_Title__g0lvX","Btn3":"RecycleBin_Btn3__1EZid","Btn1":"RecycleBin_Btn1__NhMxE"};